import { collections, constants } from "../../firebase/firestoreNameSpaces";
import { firebase } from "../../firebase/index";
import * as actionTypes from "./actionTypes";
const stockThreshold = constants.STOCK_THRESHOLD;
const expiryThreshold = constants.EXPIRY_THRESHOLD; //Days;

export const fetchStockOutProducts = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { loading: true },
      });
      let db = firebase.firestore();
      let docs = (
        await db
          .collection(collections.PRODUCTS)
          .where("someStockOut", "==", true)
          .get()
      ).docs;
      let someStockOut = [];
      docs.map((doc) => {
        let product = doc.data();

        if (product.variable) {
          let variableStock = product.variableStock;
          let variants = product.variants;
          let skeys = [];
          if (variableStock) {
            for (let skey in variableStock) {
              skeys.push(skey);
              if (variableStock[skey] < stockThreshold) {
                let variant = variants.filter(
                  (vObj) => vObj.variantId == skey
                )[0];
                if (variant) {
                  variant.stock = variableStock[skey];
                  someStockOut.push(variant);
                }
              }
            }

            variants.map((v) => {
              if (!skeys.includes(v.variantId)) {
                v.stock = 0;
                someStockOut.push(v);
              }
            });
          } else {
            variants.map((v) => {
              v.stock = 0;
              someStockOut.push(v);
            });
          }
        } else {
          if (product.stock < stockThreshold) {
            someStockOut.push(product);
          }
        }
      });

      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { loading: false, stockOutProducts: someStockOut },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { loading: false },
      });
      return alert(error);
    }
  };
};

export const updateStock = (productId, variantId, stock) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { updateBtnLoading: true },
      });

      if (stock >= stockThreshold) {
        let db = firebase.firestore();
        let productRef = db.collection(collections.PRODUCTS).doc(productId);
        if (variantId) {
          await productRef.set(
            { variableStock: { [variantId]: stock } },
            { merge: true }
          );
        } else {
          await productRef.set({ stock: stock }, { merge: true });
        }

        let stockOutProducts = getState().stock.stockOutProducts;
        let refid = variantId ? variantId : productId;
        let refidname = variantId ? "variantId" : "id";
        stockOutProducts = stockOutProducts.filter(
          (sp) => sp[refidname] != refid
        );
        dispatch({
          type: actionTypes.STOCK_CONTROLS,
          payload: {
            stockOutProducts: stockOutProducts,
            updateBtnLoading: false,
          },
        });
        return alert("Stock Updated Successfully");
      } else {
        dispatch({
          type: actionTypes.STOCK_CONTROLS,
          payload: { updateBtnLoading: false },
        });
        return alert(
          `Your Stock is Less than stock threshold = ${stockThreshold}`
        );
      }
    } catch (error) {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { updateBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const fetchExpiredProducts = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { loading: true },
      });

      const currentTime = firebase.firestore.Timestamp.now().seconds * 1000; //30 Nov
      const expiry = currentTime + expiryThreshold * 86400000; //Dec 10

      let db = firebase.firestore();
      let docs = (
        await db
          .collection(collections.PRODUCTS)
          .where("expiry", "<=", expiry)
          .get()
      ).docs;

      let expiredProducts = [];
      docs.map((doc) => {
        let product = doc.data();

        if (product.variable) {
          let variants = product.variants;
          variants.map((variant) => {
            if (variant.expiry && variant.expiry <= expiry) {
              expiredProducts.push(variant);
            }
          });
        } else {
          if (product.expiry <= expiry) {
            expiredProducts.push(product);
          }
        }
      });

      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { loading: false, expiredProducts: expiredProducts },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { loading: false },
      });
      return alert(error);
    }
  };
};

export const updateExpiry = (productId, variantId, expiry) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { updateBtnLoading: true },
      });

      const currentTime = firebase.firestore.Timestamp.now().seconds * 1000;
      const legitExpiry = currentTime + expiryThreshold * 86400000;

      if (expiry >= legitExpiry) {
        let db = firebase.firestore();
        let existingProduct = (
          await db.collection(collections.PRODUCTS).doc(productId).get()
        ).data();

        let productRef = db.collection(collections.PRODUCTS).doc(productId);
        if (variantId) {
          let existingVariants = existingProduct.variants;
          let variantExpiries = [];
          variantExpiries.push(expiry);
          existingVariants.map((variant) => {
            if (variant.variantId == variantId) {
              variant.expiry = expiry;
            } else {
              if (variant.expiry) {
                variantExpiries.push(variant.expiry);
              }
            }
          });
          let minExpiry = Math.min(...variantExpiries);
          await productRef.set(
            {
              expiry: minExpiry,
              variants: existingVariants,
            },
            { merge: true }
          );
        } else {
          await productRef.set({ expiry: expiry }, { merge: true });
        }

        let expiredProducts = getState().stock.expiredProducts;
        let refid = variantId ? variantId : productId;
        let refidname = variantId ? "variantId" : "id";
        expiredProducts = expiredProducts.filter(
          (sp) => sp[refidname] != refid
        );
        dispatch({
          type: actionTypes.STOCK_CONTROLS,
          payload: {
            expiredProducts: expiredProducts,
            updateBtnLoading: false,
          },
        });
        return alert("Expiry Updated Successfully");
      } else {
        dispatch({
          type: actionTypes.STOCK_CONTROLS,
          payload: { updateBtnLoading: false },
        });
        return alert(
          `Your Expiry is less than Expiry threshold  = ${expiryThreshold} days`
        );
      }
    } catch (error) {
      dispatch({
        type: actionTypes.STOCK_CONTROLS,
        payload: { updateBtnLoading: false },
      });
      return alert(error);
    }
  };
};
